import type { SvgProps } from 'react-native-svg';
import Svg, { Path } from 'react-native-svg';

export const ArrowUp = ({
  color,
  fill,
  stroke,
  width = 10,
  height = 12,
  ...props
}: SvgProps) => {
  const lineColor = stroke ?? color ?? fill;

  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 10 12"
      fill="none"
      {...props}
    >
      <Path
        d="M5 10.75V4.25M2.75 6.25L5 3.75L7.25 6.25"
        stroke={lineColor}
        strokeWidth={1}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};
